import { IQuestionTag, ITagData } from '@/models/configurator';
import { Question } from '@/models/configurator/question';
import { axios } from '@/plugins/axios';

export class QuestionService {
  private baseUrl = 'v1/configurator/';

  async fetchQuestions(
    module: number,
    configuration?: number
  ): Promise<Question[]> {
    const endpoint = configuration
      ? `${this.baseUrl}configurations/${configuration}/modules/${module}/questions/`
      : `${this.baseUrl}setup/modules/${module}/questions/`;
    return axios
      .get<Question[]>(`${endpoint}`, {
        timeout: 1 * (60 * 1000) //1 minute
      })
      .then(({ data }) => data);
  }

  async fetchQuestion(
    module: number,
    id: number,
    configuration?: number
  ): Promise<Question> {
    const endpoint = configuration
      ? `${this.baseUrl}configurations/${configuration}/modules/${module}/questions/${id}/`
      : `${this.baseUrl}setup/modules/${module}/questions/${id}/`;
    return axios.get<Question>(`${endpoint}`).then(({ data }) => data);
  }

  async createQuestion(question: Question): Promise<Question> {
    return axios
      .post<Question>(
        `${this.baseUrl}setup/modules/${question.module}/questions/`,
        question,
        {
          timeout: 1 * (60 * 1000) //1 minute
        }
      )
      .then(({ data }) => data);
  }

  async updateQuestion(question: Question): Promise<Question> {
    return axios
      .patch<Question>(
        `${this.baseUrl}setup/modules/${question.module}/questions/${question.id}/`,
        question,
        {
          timeout: 1 * (60 * 1000) //1 minute
        }
      )
      .then(({ data }) => data);
  }

  async deleteQuestion(question: Question): Promise<any> {
    return axios.delete(
      `${this.baseUrl}setup/modules/${question.module}/questions/${question.id}/`
    );
  }

  async updateQuestionOrder(
    module: number,
    id: number,
    order: number
  ): Promise<Question> {
    return axios
      .put<Question>(
        `${this.baseUrl}setup/modules/${module}/questions/${id}/set_order/`,
        { order }
      )
      .then(({ data }) => data);
  }

  async addQuestionTag(
    module: number,
    id: number,
    tag: IQuestionTag
  ): Promise<Question> {
    return axios
      .put<Question>(
        `${this.baseUrl}setup/modules/${module}/questions/${id}/add_tag/`,
        { tag }
      )
      .then(({ data }) => data);
  }

  async removeQuestionTag(
    module: number,
    id: number,
    tag: number
  ): Promise<Question> {
    return axios
      .put<Question>(
        `${this.baseUrl}setup/modules/${module}/questions/${id}/remove_tag/`,
        { tag }
      )
      .then(({ data }) => data);
  }

  fetchTags(): Promise<ITagData[]> {
    return axios
      .get<ITagData[]>(`${this.baseUrl}setup/tags/`)
      .then(({ data }) => data);
  }

  createTag(data: ITagData): Promise<ITagData> {
    return axios
      .post<ITagData>(`${this.baseUrl}setup/tags/`, data)
      .then(({ data }) => data);
  }

  updateTag(data: ITagData): Promise<ITagData> {
    return axios
      .patch<ITagData>(`${this.baseUrl}setup/tags/${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteTag(id: number): Promise<void> {
    return axios
      .delete(`${this.baseUrl}setup/tags/${id}/`)
      .then(({ data }) => data);
  }
}
